import React from 'react';
export function TestimonialGrid() {
  const testimonials = [{
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'María G.',
    time: '19:42',
    text: '¡No me lo creo! Lo acabo de probar por primera vez al apagarle la tablet antes de cenar y NO HA HABIDO GRITOS. Ha sido mágico 😭 Gracias de verdad.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    name: 'Laura P.',
    time: '20:15',
    text: 'Llevábamos meses que la hora de ir a dormir era una pesadilla. Con la "rampa de salida" del manual, ayer apagó él mismo el móvil. Vale cada céntimo.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
    name: 'Ana R.',
    time: '14:30',
    text: 'Se lo pasé a mi marido porque él perdía los nervios muy rápido. Ahora usamos los dos la misma frase y el ambiente en casa ha cambiado por completo ❤️'
  }];
  return <section className="py-10 px-4 bg-cream" data-id="element-150">
      <div className="max-w-5xl mx-auto" data-id="element-151">
        <div className="text-center mb-6" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-deep-blue mb-4" data-id="element-153">
            Familias reales. Tardes tranquilas.
          </h2>
          <p className="text-deep-blue/70 text-lg" data-id="element-154">
            Lo que dicen las madres que ya aplican el protocolo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-155">
          {testimonials.map((t, index) => <div key={index} className="flex flex-col gap-2" data-id="element-156">
              {/* WhatsApp style bubble */}
              <div className="bg-[#E1FFC7] rounded-2xl rounded-tl-none p-4 shadow-sm relative border border-[#d0f4b3]" data-id="element-157">
                {/* Bubble tail */}
                <div className="absolute top-0 -left-[10px] w-0 h-0 border-t-[12px] border-t-[#E1FFC7] border-l-[12px] border-l-transparent" data-id="element-158"></div>

                <div className="flex items-center gap-3 mb-3" data-id="element-159">
                  <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover shadow-sm border-2 border-white" data-id="element-160" />
                  <div className="flex-1" data-id="element-161">
                    <p className="font-bold text-gray-800 text-sm" data-id="element-162">{t.name}</p>
                  </div>
                </div>

                <p className="text-gray-800 text-[15px] leading-relaxed mb-2" data-id="element-163">
                  {t.text}
                </p>

                <div className="text-right text-[11px] text-gray-500 flex justify-end items-center gap-1" data-id="element-164">
                  {t.time}
                  <svg viewBox="0 0 16 15" width="16" height="15" className="text-[#53bdeb] fill-current" data-id="element-165">
                    <path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" data-id="element-166"></path>
                  </svg>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}